import React, { useState } from "react";
import {
    Box,
    Button,
    Typography,
    Autocomplete,
    TextField,
} from "@mui/material";
import { getAllUserApi } from "../../../api/user.js";
import SelectComponent from "../../../component/SelectComponent.js";
import MainTable from "../../../component/table/MainTable.js";
import Popup from "../../../component/popup/Popup.js";

const buttonStyle = {
    borderRadius: "10px",
    lineHeight: "normal",
    my: 1,
};

const AddNewContractorPopup = ({
    open,
    onClose,
    options,
    // category,
    onCreate,
    onSetError,
}) => {
    const INITIAL_STATE = {
        id: "",
        companyValue: "",
        companyLabel: "",
        // categoryValue: "",
        // categoryLabel: "",
        pmNameValue: "",
        pmNameLabel: "",
        pmEmail: "",
    };
    const [addNewContractorTableData, setAddNewContractorTableData] = useState(
        []
    );
    const [addNewContractorInfor, setAddNewContractorInfor] =
        useState(INITIAL_STATE);
    const [contractorPMNameOptions, setContractorPMNameOptions] = useState([]);
    const [userEmailMap, setUserEmailMap] = useState([]);

    const tableHead = [
        { id: "companyLabel", label: "Company", align: "left" },
        // { id: "categoryLabel", label: "Category", align: "left" },
        { id: "pmNameLabel", label: "Project PM Name", align: "left" },
        { id: "pmEmail", label: "Project PM Email", align: "left" },
        { id: "costModule", label: "Cost Module", align: "center", type: "switch" },
    ];

    const iconColumns = [
        {
            label: "",
            width: 25,
            note: "",
            image: "assets/icons/close.svg",
            action: async (row, event) => {
                if (event) event.stopPropagation();
                if (row) {
                    setAddNewContractorTableData((prevData) => {
                        const newData = prevData.filter((item) => item.id !== row.id);
                        return newData;
                    });
                }
            },
        },
    ];

    const conpanyNameChange = async (value, label) => {
        try {
            const result = await getAllUserApi(value);
            if (result?.data) {
                const filteredData = result.data.filter(
                    (item) => item.status !== "Disable"
                );
                const formattedData = filteredData?.map((item) => ({
                    ...item,
                    value: item.userId,
                    label: `${item.firstName} ${item.lastName}`,
                }));

                const userEmailMap = filteredData?.reduce((acc, item) => {
                    acc[item.userId] = item.email;
                    return acc;
                }, {});
                setUserEmailMap(userEmailMap);
                setAddNewContractorInfor({
                    ...addNewContractorInfor,
                    companyValue: value,
                    companyLabel: label,
                    // categoryValue: "",
                    // categoryLabel: "",
                    pmNameValue: "",
                    pmNameLabel: "",
                    pmEmail: "",
                    costModule: false
                });
                setContractorPMNameOptions(formattedData);
            }
        } catch {
            onSetError("Received user data occurred error.");
        }
    };

    const pmNameChange = async (value, label) => {
        const selectedEmail = userEmailMap[value] || "";
        setAddNewContractorInfor({
            ...addNewContractorInfor,
            id: value,
            pmNameLabel: label,
            pmNameValue: value,
            pmEmail: selectedEmail,
            costModule: false
        });
    };

    return (
        <Popup
            open={open}
            onClose={onClose}
            popupStyle={{
                minWidth: 800,
                maxWidth: 800,
            }}
            modalStyle={{
                "& .MuiBox-root.css-ft9d2q": {
                    borderRadius: "10px 10px 0 0",
                },
            }}
            title="Add New Contractor"
        >
            <Box
                sx={{
                    mx: 4,
                    mt: 2,
                    mb: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
            >
                <Box sx={{ display: "flex", gap: 1, minHeight: 150, maxHeight: 150 }}>
                    <Typography sx={{ fontSize: "11px", minWidth: 153, fontWeight: 700 }}>
                        Assigned Project Contractors:
                    </Typography>
                    <MainTable
                        sx={{ height: "100%", maxHeight: "100%" }}
                        columns={tableHead}
                        iconColumns={iconColumns}
                        rows={addNewContractorTableData}
                        headerStyles={{
                            default: {
                                background: `#F1F1F1`,
                            },
                        }}
                        onSwitchChange={(rowId, columnName, value) => {
                            setAddNewContractorTableData((prevData) =>
                                prevData.map((row) =>
                                    row.id === rowId ? { ...row, [columnName]: value } : row
                                )
                            );
                        }}
                    />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <SelectComponent
                            options={options}
                            value={addNewContractorInfor.companyValue}
                            onChange={conpanyNameChange}
                            selectLabel="Select new contractor:"
                            labelStyle={{ fontSize: "11px", minWidth: 160, fontWeight: 700 }}
                            selectStyle={{ minWidth: 248 }}
                            placeholder="Please Select the Company..."
                        />
                    </Box>
                    {/* <SelectComponent
                        options={category}
                        value={addNewContractorInfor.categoryValue}
                        onChange={(value, label) => {
                            setAddNewContractorInfor({
                                ...addNewContractorInfor,
                                categoryValue: value,
                                categoryLabel: label,
                            });
                        }}
                        labelStyle={{ fontSize: "11px", minWidth: 160, fontWeight: 700 }}
                        selectStyle={{ minWidth: 220 }}
                        placeholder="Please Select the Category..."
                    /> */}
                    <SelectComponent
                        options={contractorPMNameOptions}
                        value={addNewContractorInfor.pmNameValue}
                        onChange={pmNameChange}
                        // labelStyle={{ fontSize: "11px", minWidth: 160, fontWeight: 700 }}
                        selectStyle={{ minWidth: 248 }}
                        placeholder="Please Select the PM Name..."
                    />
                    {/* <Autocomplete
                        value={addNewContractorInfor.pmNameLabel}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                const selectedOption = contractorPMNameOptions.find((option) => option.label === newValue);
                                pmNameChange(selectedOption?.value, selectedOption?.label);
                            } else {
                                pmNameChange(null, null);
                            }
                        }}
                        freeSolo
                        options={contractorPMNameOptions.map((e) => e.label)}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => <TextField {...params} placeholder="Please Select Email..." />}
                        sx={{
                            minWidth: 220,
                            my: 0.5,
                            '& .MuiAutocomplete-inputRoot': { py: 0 },
                            '& .MuiAutocomplete-input': { p: '4px 7px!important' },
                            '& .MuiAutocomplete-tag': { height: 24 }
                        }}
                    ></Autocomplete> */}
                    <Button
                        disabled={
                            !addNewContractorInfor.companyValue ||
                            !addNewContractorInfor.pmNameValue
                        }
                        color={
                            !addNewContractorInfor.companyValue ||
                                !addNewContractorInfor.pmNameValue
                                ? "primary"
                                : "secondary"
                        }
                        onClick={() => {
                            const isDuplicate = addNewContractorTableData.some(
                                (item) => item.pmNameValue === addNewContractorInfor.pmNameValue
                            );

                            if (isDuplicate) {
                                onSetError("This contractor has already been assigned.");
                                return;
                            }
                            setAddNewContractorTableData((prevData) => [
                                ...prevData,
                                addNewContractorInfor,
                            ]);
                        }}
                        variant="contained"
                        sx={buttonStyle}
                    >
                        Add
                    </Button>
                </Box>
                <Box textAlign="center">
                    <Button
                        sx={buttonStyle}
                        onClick={() => onCreate(addNewContractorTableData)}
                        variant="contained"
                        disabled={addNewContractorTableData.length === 0}
                        color={
                            addNewContractorTableData.length === 0 ? "primary" : "success"
                        }
                    >
                        Create
                    </Button>
                </Box>
            </Box>
        </Popup>
    );
};

export default AddNewContractorPopup;
